// extracted by mini-css-extract-plugin
module.exports = {"Attention":"Attention_Attention__2tYfk","AttentionIcon":"Attention_AttentionIcon__2g3fl"};